import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Table,
  Modal,
  Cascader,
  Button,
  Form,
  Input,
  Upload,
  message,
} from "antd";
import RenderTxt from "@components/renderTxt";
import stationApi from "@api/station";
import { UploadOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import SystemApi from "@api/sys";
import { findAllParents } from "../../../utils/common";
import SearchForm from "@components/SearchForm";

const { UPLOADER } = window.globalConfig;

const fieldNames = {
  label: "itemName",
  value: "id",
  children: "children",
};

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
const KnowledgeBase = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [form] = Form.useForm();
  const [deviceList, setDeviceList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [tableSource, setTableSource] = useState({});
  const [inputList] = useState([
    {
      label: "设备名称:",
      name: "deviceName",
      message: "请输入设备名称",
      span: 8,
      labelCol: 6,
    },
  ]);

  const columns = [
    {
      title: "设备名称",
      dataIndex: "deviceName",
      align: "center",
      key: "deviceName",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "内容",
      dataIndex: "knowledgeContent",
      align: "center",
      key: "knowledgeContent",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "附件",
      dataIndex: "knowledgeAnnex",
      align: "center",
      key: "knowledgeAnnex",
      render: (text) => {
        if (!text) {
          return "无";
        } else {
          const arr = text.includes(",") ? text.split(",") : [text];
          return arr.map((item) => (
            <a
              key={item}
              target="_blank"
              style={{ display: "block" }}
              href={item}
            >
              {item}
            </a>
          ));
        }
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      key: "action",
      render: (text, obj) => {
        return (
          <>
            <Button type="primary" onClick={() => editFn(obj)}>
              编辑
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              type="primary"
              danger
              onClick={() => delRecord(obj.id)}
            >
              删除
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    getDevice();
  }, []);

  useEffect(() => {
    getListPages();
  }, [searchParams]);

  const getListPages = () => {
    setLoading(true);
    SystemApi.knowledgeBaseList(searchParams).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      res.data.data.map((item) => {
        item.key = item.id;
      });
      setTableSource(res.data);
    });
  };

  const editFn = (obj) => {
    setEditId(obj.id);
    setVisible(true);
    const deviceId = findAllParents(
      deviceList,
      obj.deviceId,
      [],
      "number",
      "children"
    );
    form.setFieldsValue({
      ...obj,
      deviceId,
    });
    // 编辑时回显已有附件
    if (obj.knowledgeAnnex) {
      const urls = obj.knowledgeAnnex.includes(",")
        ? obj.knowledgeAnnex.split(",")
        : [obj.knowledgeAnnex];
      setFileList(
        urls.map((url, i) => ({
          uid: `${-i - 1}`,
          name: decodeURIComponent(url.split("/").pop() || `附件${i + 1}`),
          status: "done",
          url,
          response: { status: "0", data: { url } },
        }))
      );
    } else {
      setFileList([]);
    }
  };

  const delRecord = (id) => {
    Modal.confirm({
      onOk: () => {
        SystemApi.knowledgeBaseRemove({ id }).then((res) => {
          if (res.status !== "0") return;
          message.success("删除成功");
          getListPages();
        });
      },
      title: "请确认",
      icon: <ExclamationCircleOutlined />,
      content: "是否删除",
      okText: "确认",
      cancelText: "取消",
    });
  };

  const getDevice = () => {
    stationApi.getDeviceByStationId({ stationId }).then((res) => {
      if (res.status !== "0") return;
      const ls = getTreeData(res.data);
      setDeviceList(ls);
    });
  };

  const getTreeData = (data) => {
    return data.map((item) => {
      return {
        ...item,
        id: item.deviceId ? item.deviceId : item.id,
        children: item.child.length ? getTreeData(item.child) : undefined,
        child: undefined,
      };
    });
  };

  const uploadProps = {
    name: "file",
    action: UPLOADER,
    fileList: fileList,
    headers: {
      authorization: sessionStorage.getItem("token"),
    },
    onChange(info) {
      setFileList([...info.fileList]);
    },
  };

  const cancel = () => {
    setVisible(false);
    form.resetFields();
    setEditId(null);
    setFileList([]);
  };

  const save = () => {
    form.validateFields().then((values) => {
      const params = {
        ...values,
        knowledgeAnnex:
          fileList.length > 0
            ? fileList
                .filter((f) => f.status === "done")
                .map((f) => f.url || f.response?.data?.url)
                .filter(Boolean)
                .join(",")
            : undefined,
        deviceId: values.deviceId[values.deviceId.length - 1],
      };
      if (editId) {
        setConfirmLoading(true);
        SystemApi.knowledgeBaseUpdate({ ...params, id: editId }).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("修改成功");
          cancel();
          getListPages();
        });
      } else {
        setConfirmLoading(true);
        SystemApi.knowledgeBaseAdd(params).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("添加成功");
          cancel();
          getListPages();
        });
      }
    });
  };

  const add = () => {
    setFileList([]);
    setVisible(true);
  };

  const handleTableChange = (pagination) => {
    const params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  const search = (values) => {
    const params = {
      ...values,
      pageNum: 1,
      pageSize: 10,
    };
    setSearchParams(params);
  };

  return (
    <div style={{ padding: 10 }}>
      <SearchForm span={6} inputList={inputList} onSearch={search} />
      <Button type="primary" style={{ marginBottom: 10 }} onClick={add}>
        新增
      </Button>
      <Table
        loading={loading}
        columns={columns}
        dataSource={tableSource.data}
        pagination={{
          current: tableSource.pageNum,
          pageSize: tableSource.pageSize,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total) => `共${total}条数据`,
          total: tableSource.total * 1,
        }}
        onChange={handleTableChange}
      />
      {visible && (
        <Modal
          title={editId ? "编辑" : "新增"}
          open={visible}
          onCancel={cancel}
          onOk={save}
          confirmLoading={confirmLoading}
        >
          <Form {...layout} form={form}>
            <Form.Item
              label="设备"
              name="deviceId"
              rules={[{ required: true, message: "请选择设备!" }]}
            >
              <Cascader
                fieldNames={fieldNames}
                options={deviceList}
                placeholder="请选择设备"
              />
            </Form.Item>
            <Form.Item
              label="内容"
              name="knowledgeContent"
              rules={[{ required: true, message: "请输入内容!" }]}
            >
              <Input.TextArea row={4} placeholder={"请输入内容"} />
            </Form.Item>
            <Form.Item label="附件">
              <Upload {...uploadProps}>
                <Button icon={<UploadOutlined />}>上传</Button>
              </Upload>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(KnowledgeBase);
